export default __webpack_public_path__ + "static/media/situation-coref-assign-situation.0d70fa49.gif";